import http from "@/libs/http"

type UpdateEmailResponse = {
  new_values?: {
    email?: string | null
  }
}

export const updateMarketingEmail = async (email: string) => {
  const { data } = await http.post<UpdateEmailResponse>("api/user/settings", { email: email.trim() })
  return data
}

export const updateEmailMarketingConsent = async (emailAccepted: boolean) => {
  const { data } = await http.post("api/auth/update-email-accepted", { email_accepted: emailAccepted })
  return data
}
